import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate } from "react-router-dom";
import { getAppContent, saveAppContent, getS3Config } from "../../api/apiHandler";
import { showMessage, showErrorMessage } from "../common/Utils";
import { Editor } from '@tinymce/tinymce-react';

export function Privacycmsupdate() {

    let navigate = useNavigate();
    const editorRef = useRef(null);
    const [editorData, setEditorData] = useState("<p></p>");
    const [ s3Config, setS3Config ] = useState({});

    useEffect(() => {
        async function getAppData() {

            const confResponse = await getS3Config({});
            if (parseInt(confResponse.code) === 1) {
                setS3Config(confResponse.data);
            }

            const contentReq = {
                type: 'policy_content'
            }
            const response = await getAppContent(contentReq);
            if (parseInt(response.code) === 1) {
                setEditorData(response.data.content_value || "<p></p>");
            } else {
                showErrorMessage(response.message);
            }
        }
        getAppData();
    }, []);
    
    useEffect(() => {
        setEditorData(editorData);
    }, [editorData]);

    const handleAddRequest = async(e) => {
        e.preventDefault();
        
        // get updated editor data
        setEditorData(editorRef.current.getContent());

        const addAbout = {
            content_key: 'policy_content',
            content_value: editorRef.current.getContent(),
        };
        const response = await saveAppContent(addAbout);
        if (parseInt(response.code) === 1) {
            showMessage(response.message);
            navigate('/app-content/privacy-policy');
        } else {
            showErrorMessage(response.message);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Privacy Policy update</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                        <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/app-content/privacy-policy">
                                        Privacy Policy
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Privacy Policy update</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="header">
                                    <div className="col-12 text-left">
                                        <a 
                                            href="#"
                                            onClick={handleGoBack} 
                                            className="btn btn-raised bg-primary waves-effect waves-red text-left"
                                        >
                                                <i className="zmdi zmdi-arrow-left"></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="body">                                    
                                    <form name="editPrivacyPolicy" id="editPrivacyPolicy" onSubmit={handleAddRequest}>
                                        <div className="col-md-12 col-lg-12 col-xl-12">
                                            <center><h4>Privacy Policy content</h4></center>
                                            <hr />
                                            { s3Config.REACT_APP_TINYMCE_API_KEY ? (
                                                <Editor
                                                    apiKey={s3Config.REACT_APP_TINYMCE_API_KEY}
                                                    onInit={(_evt, editor) => editorRef.current = editor}
                                                    initialValue={editorData.toString()}
                                                    init={{
                                                        height: 500,
                                                        menubar: false,
                                                        plugins: [
                                                            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                        ],
                                                        toolbar: 'undo redo | blocks | ' +
                                                            'bold italic forecolor | alignleft aligncenter ' +
                                                            'alignright alignjustify | bullist numlist outdent indent | ' +
                                                            'removeformat | help',
                                                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                                    }}
                                                />
                                            ) : (
                                                <p>Loading editor...</p>
                                            )}
                                        </div>
                                        <div className="clearfix" />
                                        <div className="col-md-2 col-lg-2 col-xl-2 offset-md-5">
                                            <div className="form-group">
                                                <button type="submit" className="btn btn-raised btn-primary waves-effect m-t-20 mr-3">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}